import { deviceConstraints } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { HeaderNotificationTypeEnum } from '~/shared/components/header-notification-buttons/HeaderNotificationButton';

export const NotificationButton = styled.span<{
  withText: boolean;
  $type: HeaderNotificationTypeEnum;
}>`
  display: flex;
  align-items: center;
  border-radius: 16px;
  height: 24px;
  white-space: nowrap;
  cursor: pointer;
  background-color: transparent;
  color: var(--primary-color);

  ${({ $type }) =>
    $type === HeaderNotificationTypeEnum.ERROR &&
    css`
      color: var(--failure--default);
    `}

  ${({ withText, $type }) =>
    withText &&
    css`
      @media ${deviceConstraints.desktopSmall} {
        padding: 0 12px;
        border: 1px solid;
        background-color: var(--primary-color);
        color: var(--base--100);

        ${$type === HeaderNotificationTypeEnum.ERROR &&
        css`
          background-color: var(--failure--default);
          color: var(--base--100);
        `}
      }
    `}
`;

export const IconWrapper = styled.span<{ withText: boolean }>`
  display: flex;

  ${({ withText }) =>
    withText &&
    css`
      @media ${deviceConstraints.desktop} {
        margin-left: -10px;
        margin-right: 6px;
      }
    `}
`;

export const ButtonText = styled.span`
  display: none;
  font-size: 14px;

  @media ${deviceConstraints.desktopSmall} {
    display: inline;
  }
`;
